import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function QuickActionCard({ data, type, onClick }) {
  const { user } = useSelector((state) => state.auth);
  const {t} = useTranslation()
  return (
    <Stack
      className="px-[16px] w-[270px] pt-[16px]"
      style={{ backgroundColor: type === 'action' ? '#0033990D' : '#FFFFFF', borderRadius: '8px', borderWidth: type === 'access' ? '1px' : '0px', borderColor: type === 'access' ? '#8993AC26' : null, cursor: 'pointer' }}
      onClick={() => onClick()}
    >
      <Stack direction={'row'}>
        <Stack className="mr-[16px]">
          {/* <img
            src={data?.icon}
            width={'80px'}
            height={'80px'}
          /> */}
          <img
            src={data?.icon}
            width={'40px'}
            height={'40px'}
          />
        </Stack>

        <Stack>
          <Typography
            className="ff-Roboto fw-medium fs-16"
            color={'#003399'}
          >
            {data?.title === t('Contact Management') && user?.type === 'trader' ? t('Client Management') : t(data?.title)}
          </Typography>
          <Typography
            className="ff-Roboto fw-regular fs-12"
            color={'#14285A80'}
          >
            {/* {data?.title === 'Contact Management' && user?.type === 'trader' ? `Let's explore our trade management system module` : data?.desc} */}
            {data?.title === 'Contact Management' && user?.type === 'trader' ? ` ` : ` `}
            
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf={'flex-end'}>
        <IconButton>
          <ArrowOutwardIcon color="#8993AC80" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
